import React, { Component } from 'react';
import { Col } from "antd";
import '../components-style.css';
import {FormattedMessage} from 'react-intl';

//Position img
import stand from '../../Images/Position/stand.png';
import belly from '../../Images/Position/belly.png';
import back from '../../Images/Position/back.png';
import rightSide from '../../Images/Position/right-side.png';
import leftSide from '../../Images/Position/left-side.png';
import upsideDown from '../../Images/Position/upside-down.png';

//Position img for alerts
import stand_alert from '../../Images/Position/stand-alert.png';
import back_alert from '../../Images/Position/back-alert.png';
import rightSide_alert from '../../Images/Position/right-side-alert.png';
import leftSide_alert from '../../Images/Position/left-side-alert.png';
import upsideDown_alert from '../../Images/Position/upside-down-alert.png';
import belly_alert from '../../Images/Position/belly-alert.png';

class PositionDisplay extends Component {

    //Function to get position icon depending on position received
    getPositionIcon = (position, alert) => {

        //Stand position
        if(position === 1){
            if(alert){
                return(
                    <img
                        src={stand_alert}
                        style={{ height: "auto", maxHeight: "55px", width: "auto"}}
                        alt="position-stand-alert"  
                    />
                );  
            }
            else{
                return(
                    <img
                        src={stand}
                        style={{ height: "auto", maxHeight: "55px", width: "auto" }}
                        alt="position-stand"  
                    />
                );  
            }
        }

        //Position supine decubitus (Back)
        if(position === 2){
            if(alert){
                return(
                    <img
                        src={back_alert}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "70%" }}
                        alt="position-back-alert"     
                    />
                );
            }
            else{
                return(
                    <img
                        src={back}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "70%" }}
                        alt="position-back"     
                    />
                );
            }
        }

        //Position prone decubitus (belly)
        if(position === 3){
            if(alert){
                return(
                    <img
                        src={belly_alert}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "70%" }}
                        alt="position-belly-alert"  
                    />
                );
            }
            else{
                return(
                    <img
                        src={belly}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "70%" }}
                        alt="position-belly"  
                    />
                );
            }
        }

        //Position right lateral decubitus (right side)
        if(position === 4){
            if(alert){
                return(
                    <img
                        src={rightSide_alert}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "60%" }}
                        alt="position-righ-side-alert" 
                    />
                );
            }
            else{
                return(
                    <img
                        src={rightSide}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "60%" }}
                        alt="position-righ-side" 
                    />
                );
            }
        }

        //Position left lateral decubitus (left side)
        if(position === 5){
            if(alert){
                return(
                    <img
                        src={leftSide_alert}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "60%" }}
                        alt="position-left-side-alert" 
                    />
                );
            }
            else{
                return(
                    <img
                        src={leftSide}
                        style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "60%" }}
                        alt="position-left-side" 
                    />
                );
            }
        }

        //Upside down position
        if(position === 6){
            if(alert){
                return(                                            
                    <img
                        src={upsideDown_alert}
                        style={{ height: "auto", maxHeight: "55px", width: "auto" }}
                        alt="position-upside-down-alert"  
                    />
                );
            }
            else{
                return(                                            
                    <img
                        src={upsideDown}
                        style={{ height: "auto", maxHeight: "55px", width: "auto" }}
                        alt="position-upside-down"  
                    />
                );
            }
        }

        //Display "NC" if position is not defined
        else{
            return(null);
        }
    }

    ///Render to be displayed
   	render(){

        return(
            <Col id="col-position">
                {(this.props.alert) ?
                    <Col id="col-icon-alert">
                        {this.getPositionIcon(this.props.position, this.props.alert)}
                    </Col>
                    :
                    <Col id="col-icon">
                        {this.getPositionIcon(this.props.position, this.props.alert)}
                    </Col>
                }
            </Col>
        );
   	}
}
export default (PositionDisplay);